import app from './firebase';
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getFunctions, httpsCallable } from "firebase/functions";
import "./StockSuccess.css";

export default function StockSuccess() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | ready | error
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [clipTitle, setClipTitle] = useState("");

  useEffect(() => {
    const sessionId = searchParams.get("session_id");
    if (!sessionId) {
      setStatus("error");
      return;
    }

    const functions = getFunctions(app);
    const getDownload = httpsCallable(functions, "getStockDownload");

    getDownload({ sessionId })
      .then((result) => {
        setDownloadUrl(result.data.url);
        setClipTitle(result.data.clipTitle);
        setStatus("ready");
      })
      .catch((err) => {
        console.error(err);
        setStatus("error");
      });
  }, [searchParams]);

  return (
    <div className="success-page">
      <div className="success-card">
        <div className="success-logo">STIMU Stock</div>

        {status === "loading" && (
          <>
            <div className="success-spinner" />
            <p className="success-msg">Preparing your download…</p>
          </>
        )}

        {status === "ready" && (
          <>
            <div className="success-icon">✓</div>
            <h2 className="success-heading">Purchase complete</h2>
            <p className="success-clip">{clipTitle}</p>
            <p className="success-msg">
              Your HD file is ready. The download link expires in 60 minutes.
            </p>
            <a
              className="download-btn"
              href={downloadUrl}
              download
              target="_blank"
              rel="noreferrer"
            >
              Download HD clip
            </a>
            <p className="success-note">
              Thank you — 50% of this purchase supports children in Nepal
              through <a href="https://janmadin.com" target="_blank" rel="noreferrer">Janmadin.com</a>.
            </p>
          </>
        )}

        {status === "error" && (
          <>
            <h2 className="success-heading">Something went wrong</h2>
            <p className="success-msg">
              Your payment may still have gone through. Please email{" "}
              <a href="mailto:hello@stimu.app">hello@stimu.app</a> with your
              order details and we'll sort it within 24 hours.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
